// extracted by mini-css-extract-plugin
export var audio = "PostMedia-module--audio--b5b2d";
export var audioImage = "PostMedia-module--audioImage--73e97";
export var audioPlayArrow = "PostMedia-module--audioPlayArrow--5905b";
export var audioPlayCircle = "PostMedia-module--audioPlayCircle--f5894";
export var controls = "PostMedia-module--controls--a2bd0";
export var playButton = "PostMedia-module--playButton--6b256";
export var root = "PostMedia-module--root--3b566";